import classNames from "classnames";
import { useAppSelector } from "hooks/redux";
import { websiteBuilderGenerateNavigationMenuDesignStyles } from "pages/secure/facility/websiteBuilder/editor/nodes/element/websiteBuilderNavigationMenu";
import React, { ReactNode } from "react";
import { TWebsiteBuilderWebsiteVersionNavigationMenuItem } from "redux/reducers/models/websiteBuilder";

export function WebsiteBuilderNavigationMenuView() {
  const designStyles = websiteBuilderGenerateNavigationMenuDesignStyles();

  const pageMap = useAppSelector(store => store.websiteBuilderStore.editor.pageMap);
  const activePageId = useAppSelector(store => store.websiteBuilderStore.editor.activePageId);
  const navigationMenuItems = useAppSelector(store => store.websiteBuilderStore.editor.navigationMenuItems);
  const deviceView = useAppSelector(store => store.websiteBuilderStore.editor.deviceView);

  function getLinkText(navigationMenuItem: TWebsiteBuilderWebsiteVersionNavigationMenuItem) {
    if (navigationMenuItem.type === "page") {
      const itemPage = pageMap.get(navigationMenuItem.page_id);

      return itemPage?.title ?? "";
    } else {
      return navigationMenuItem.label;
    }
  }

  function renderNavigationMenuItems(): ReactNode {
    if (deviceView !== "desktop") {
      return null;
    }
    
    return navigationMenuItems?.map(item => {
      if (!item.hidden) {
        if (item.type !== "dropdown") {
          return (
            <a
              key={item.id}
              className={classNames(designStyles.linkClassName, "editor-navigation-menu-link", {
                [designStyles.linkActiveClassName]: item.type === "page" && item.page_id === activePageId,
              })}
            >
              {getLinkText(item)}
            </a>
          );
        } else {
          return (
            <div
              key={item.id}
              className={designStyles.dropbuttonClassName}
            >
              {`${item.label} ▼`}
            </div>
          );
        }
      } else {
        return null;
      }
    });
  }

  return (
    <nav
      className={classNames(designStyles.className, "editor-navigation-menu")}
      style={designStyles.styleProperties}
    >
      {renderNavigationMenuItems()}
    </nav>
  );
}
